import PropTypes from 'prop-types';
import { CatInlineNotification } from '@blocks-react/components/InlineNotification';
import { CatIconWarningCircle } from '@blocks-react/components/Icons/WarningCircle';
import { CatIconSuccess } from '@blocks-react/components/Icons/Success';
import { SUCCESS } from '@app/constants/commonConstants';

const SystemFeedbackBanner = ({
  heading,
  variant = '',
  description = '',
  dismissible = false,
  close = () => {}
}) => {
  const isSuccessBanner = variant === SUCCESS;
  return (
    <CatInlineNotification
      heading={heading}
      variant={variant}
      dismissible={dismissible}
      onBlInlineNotificationClose={close}
    >
      {isSuccessBanner ? (
        <CatIconSuccess slot="before" />
      ) : (
        <CatIconWarningCircle slot="before" />
      )}
      {description ? description : null}
    </CatInlineNotification>
  );
};

SystemFeedbackBanner.propTypes = {
  heading: PropTypes.string,
  variant: PropTypes.string,
  description: PropTypes.string,
  dismissible: PropTypes.bool,
  close: PropTypes.func
};

export default SystemFeedbackBanner;
